import React from "react";
import { FiSun, FiCloud, FiMoon } from "react-icons/fi";
import { useTheme } from "../store/ThemeContext";

const OPTIONS = [
  { id: "light", label: "Light", icon: FiSun },
  { id: "medium", label: "Medium", icon: FiCloud },
  { id: "dark", label: "Dark", icon: FiMoon },
];

const ThemeSelector = ({ compact = false }) => {
  const { theme, setTheme } = useTheme();

  if (compact) {
    return (
      <div
        className="theme-toggle inline-flex rounded-lg border border-theme-border bg-theme-surface-muted p-0.5"
        role="radiogroup"
        aria-label="Color theme"
      >
        {OPTIONS.map(({ id, label, icon: Icon }) => (
          <button
            key={id}
            type="button"
            role="radio"
            aria-checked={theme === id}
            aria-label={label}
            title={label}
            onClick={() => setTheme(id)}
            className={`flex h-8 w-8 items-center justify-center rounded-md transition-colors ${
              theme === id
                ? "bg-brand-600 text-white shadow-sm"
                : "text-theme-muted hover:bg-theme-surface-hover hover:text-theme-text"
            }`}
          >
            <Icon className="h-4 w-4" />
          </button>
        ))}
      </div>
    );
  }

  return (
    <div className="surface-card p-4">
      <p className="mb-3 text-xs font-semibold uppercase tracking-wider text-theme-muted">
        Appearance
      </p>
      <div className="grid grid-cols-3 gap-2" role="radiogroup" aria-label="Color theme">
        {OPTIONS.map(({ id, label, icon: Icon }) => (
          <button
            key={id}
            type="button"
            role="radio"
            aria-checked={theme === id}
            onClick={() => setTheme(id)}
            className={`flex flex-col items-center gap-1.5 rounded-lg border px-2 py-3 text-xs font-semibold transition-all ${
              theme === id
                ? "border-brand-500 bg-theme-accent text-brand-600 shadow-sm"
                : "border-theme-border bg-theme-surface-muted text-theme-muted hover:border-theme-border hover:bg-theme-surface-hover hover:text-theme-text"
            }`}
          >
            <Icon className="h-4 w-4" />
            {label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default ThemeSelector;
